import Phaser from 'phaser';
import { CST } from '../../../CST';
import { Score } from '../../../controller/score.js';

var pos = 0;

export default class Storyboard_1 extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.STORYBOARD_1);
	}

	init() {
		pos = 0;
	}

	preload() {
		this.load.image('forgetting-me-bg', 'assets/Storyboards/forgettingme_background.png');
	}

	create(data) {
		const map = this.add.image(0, 0, 'forgetting-me-bg').setOrigin(0);

		const cam = this.cameras.main;
		cam.setBounds(0, 0, 4401, 9465); //Left, Top, X Limit, Y Limit
		cam.setZoom(0.6); //0.8
		cam.centerOn(1189, 695); //1100, 800

		this.clickSound = this.sound.add('click-sound', {
			volume: 0.5,
		});

		this.score = new Score(this);
		this.User_ID = data.User_ID;

		data.next
			.setInteractive({
				useHandCursor: true,
			})
			.on(
				'pointerdown',
				() => {
					this.clickSound.play();
					pos++;
					data.next.disableInteractive();
					data.previous.disableInteractive();
					setTimeout(() => {
						data.next.setInteractive();
						data.previous.setInteractive();
					}, 1500);
					switch (pos) {
						case -1:
							pos = 0;
							break;
						case 1:
							cam.pan(3433, 750, 1000);
							break;
						case 2:
							cam.pan(2200, 2100, 1000);
							cam.zoomTo(0.4, 1000);
							break;
						case 3:
							cam.pan(2200, 3900, 1000);
							cam.zoomTo(0.35, 1000);
							break;
						case 4:
							cam.pan(1189, 5350, 1000);
							cam.zoomTo(0.7, 1000);
							break;
						case 5:
							cam.pan(3433, 5300, 1000);
							break;
						case 6:
							cam.pan(2300, 6800, 1000);
							cam.zoomTo(0.38, 1000);
							break;
						case 7:
							cam.pan(2200, 8500, 1000);
							cam.zoomTo(0.4, 1000);
							break;
						case 8:
							pos = 0;
							data.next.setVisible(false);
							data.previous.setVisible(false);
							data.pause.setVisible(false);
							this.scene.resume(CST.SCENES.MAIN_QUESTIONS, {
								User_ID: this.User_ID,
								story: 1,
							});
							this.scene.stop();
							break;
						default:
							break;
					}
				},
				this,
			);

		data.previous
			.setInteractive({
				useHandCursor: true,
			})
			.on(
				'pointerdown',
				() => {
					this.clickSound.play();
					pos--;
					data.next.disableInteractive();
					data.previous.disableInteractive();
					setTimeout(() => {
						data.next.setInteractive();
						data.previous.setInteractive();
					}, 1500);
					switch (pos) {
						case -1:
							pos = 0;
							break;
						case 0:
							cam.pan(1189, 695, 1000);
							break;
						case 1:
							cam.pan(3433, 650, 1000);
							cam.zoomTo(0.7, 1000);
							break;
						case 2:
							cam.pan(2200, 2100, 1000);
							cam.zoomTo(0.4, 1000);
							break;
						case 3:
							cam.pan(2200, 3900, 1000);
							cam.zoomTo(0.5, 1000);
							break;
						case 4:
							cam.pan(1189, 5350, 1000);
							break;
						case 5:
							cam.pan(3433, 5300, 1000);
							cam.zoomTo(0.7, 1000);
							break;
						case 6:
							cam.pan(2300, 6800, 1000);
							cam.zoomTo(0.38, 1000);
							break;
						case 7:
							cam.pan(2200, 8500, 1000);
							cam.zoomTo(0.4, 1000);
							break;
					}
				},
				this,
			);
	}
}
